import type { CSSProperties } from "react";

const base: CSSProperties = {
  fontFamily: "var(--f-mono)",
  fontSize: 9,
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  fontWeight: 500,
  color: "var(--fg-hi)",
  background: "transparent",
  border: "1px solid var(--line-3)",
  padding: "4px 10px",
  height: 22,
  cursor: "pointer",
  borderRadius: 2,
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  whiteSpace: "nowrap",
};

export function ExploreCTA({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "var(--brand)";
        e.currentTarget.style.borderColor = "var(--brand)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "var(--fg-hi)";
        e.currentTarget.style.borderColor = "var(--line-3)";
      }}
      style={base}
    >
      EXPLORE MARKETS
      <span style={{ fontSize: 11, lineHeight: 1 }}>→</span>
    </button>
  );
}
